/**
 * getLanguage - returns the active language from the URL prefix
 * @returns {string} language code ('sk' | 'en'), defaults to 'sk'
 * @see src/components/LanguageLayout.tsx
 */
export default function getLanguage(): string {
    const supported = ['sk', 'en'];
    const first = window.location.pathname.split('/').filter(Boolean)[0];
    return supported.includes(first) ? first : 'sk';
}
